import { QUERY_BUILDER_OPEN_BRACKET } from '../../../../types';
import { ResolveOptionSubmitActionResultType } from '../../resolveOptionSubmitAction';

export const resolveOperandOptionSubmitAction = (
  value: string
): ResolveOptionSubmitActionResultType => {
  if (value === QUERY_BUILDER_OPEN_BRACKET) {
    return {
      action: { type: 'openBracket' },
      shouldReopenDropdownAfterSubmit: false,
    };
  }

  return {
    action: { type: 'entity', entityKey: value },
    shouldReopenDropdownAfterSubmit: true,
  };
};
